import { NgModule }     from '@angular/core';
import { CommonModule } from '@angular/common';

import { VirtualScrollerModule } from './virtual-scroller/virtual-scroller.module';

import { AlertBoxModule }        from './alert-box/alert-box.module';
import { AnchorModule }          from './anchor/anchor.module';
import { IconsModule }           from './icons/icons.module';
import { MaterialModule }        from './material/material.module';
import { PipesModule }           from './pipes/pipes.module';
import { ImageModule }           from './image/image.module';
import { ModalsModule }          from '@modals/modals.module';
import { TimerComponent }        from './timer/timer.component';
import { EditorModule }          from './editor/editor.module';
import { QuestionnaireModule }   from './questionnaire/questionnaire.module';
import { AdjustableImageModule } from './adjustable-image/adjustable-image.module';
import { SliderComponent }       from './slider/slider.component';
import { SectionsModule }        from './sections/sections.module';
import { LoadingModule }         from './loading/loading.module';
import { ChartsModule }          from './charts/charts.module';
import { CanvasModule }          from './canvas/canvas.module';
import { UiModule }              from './ui/ui.module';


@NgModule({
  declarations: [
    TimerComponent,
    SliderComponent
  ],
  imports:      [
    CommonModule,
    AlertBoxModule,
    AnchorModule,
    IconsModule,
    VirtualScrollerModule,
    MaterialModule,
    PipesModule,
    ModalsModule,
    ImageModule,
    EditorModule,
    QuestionnaireModule,
    AdjustableImageModule,
    SectionsModule,
    LoadingModule,
    ChartsModule,
    CanvasModule,
    UiModule,
  ],
  exports:      [
    AlertBoxModule,
    AnchorModule,
    IconsModule,
    VirtualScrollerModule,
    MaterialModule,
    PipesModule,
    ModalsModule,
    ImageModule,
    TimerComponent,
    QuestionnaireModule,
    AdjustableImageModule,
    SectionsModule,
    SliderComponent,
    LoadingModule,
    ChartsModule,
    CanvasModule,
    UiModule
  ]
})
export class SharedModule {}
